import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsEstabelecimentoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/estabelecimento');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Estabelecimento');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/estabelecimento', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Estabelecimento');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/estabelecimento', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Estabelecimento');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/estabelecimento/findOne/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Estabelecimento');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/estabelecimento/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Estabelecimento');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/estabelecimento/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Estabelecimento');
    }
  }
}
